import { Employee } from "@finway-group/shared/lib/models"
import UserCompanyProfileInterface from "@finway-group/shared/lib/models/user/userCompanyProfileInterface"
import { useSelector } from "react-redux"
import { FINWAY_ADMIN_EMAIL } from "Shared/config/consts"
import { UserService } from "Shared/services"
import { RootState } from "Shared/store/rootState.interface"
import { useCompany } from "./company.hooks"
import store from "Shared/store"

export const useEmployees = (excludeDeleted: boolean = false, filtered: boolean = false, includeAutoApprover: boolean = false, searchValue?: string) => {
    let employees = useSelector(({ employees }: RootState) => employees.items)
    const selectedCompanyId = useCompany()._id
    const { activeCompanyProfile } = UserService.getLoggedInEmployeeProfile()
    return filterEmployees(employees, selectedCompanyId, activeCompanyProfile, excludeDeleted, filtered, includeAutoApprover, searchValue)
}

export const getEmployeesFromStore = (excludeDeleted: boolean = false, filtered: boolean = false, includeAutoApprover: boolean = false, searchValue?: string) => {
    let employees = store.getState().employees.items
    const selectedCompanyId = store.getState().company.item._id
    const { activeCompanyProfile } = UserService.getLoggedInEmployeeProfile()
    return filterEmployees(employees, selectedCompanyId, activeCompanyProfile, excludeDeleted, filtered, includeAutoApprover, searchValue)
}

//prettier-ignore
const filterEmployees = (employees: any, selectedCompanyId: any, activeCompanyProfile: any, excludeDeleted: boolean = false, filtered: boolean = false, includeAutoApprover: boolean = false, searchValue?: string ): Employee[] => {
    employees = employees.map((employee: any) => {
        const employeeObject = new Employee(employee)
        employeeObject.activeCompanyProfile = employeeObject.getUserCompanyProfile(selectedCompanyId) || ({} as UserCompanyProfileInterface)
        return employeeObject
    })

    if (!includeAutoApprover) {
        employees = employees.filter((employee: any) => employee.email !== FINWAY_ADMIN_EMAIL)
    }

    if (excludeDeleted) {
        employees = employees?.filter((employee: Employee) => employee.activeCompanyProfile.companyId && !employee.activeCompanyProfile.deleted)
    }

    if (filtered) {
        employees = employees?.filter(
            (employee: Employee) => activeCompanyProfile.isAdmin || (activeCompanyProfile.isApprover && employee.activeCompanyProfile?.team === activeCompanyProfile.team)
        )
    }

    if (searchValue) {
        employees = employees.filter(
            (employee: Employee) => employee.firstName.toLowerCase().includes(searchValue.toLowerCase()) || employee.lastName.toLowerCase().includes(searchValue.toLowerCase())
        )
    }

    return employees.sort((a: Employee, b: Employee) => a.firstName?.localeCompare(b.firstName))
}

export const useEmployeeById = (id: string) => useEmployees().find((employee: Employee) => employee.id === id)

export const useEmployee = () => new Employee(useSelector(({ employees }: RootState) => employees.item))

export const useLoggedInEmployee = () => {
    const { id } = UserService.getLoggedInUserProfile()
    return new Employee(useSelector(({ employees: { items } }: RootState) => items.find((employee) => employee.id === id)))
}

export const useEmployeeLanguage = () => useLoggedInEmployee().getUserLanguage()
